export default __webpack_public_path__ + "static/media/yoga_pose.9d642827.jpg";